"use client"

import { useEffect } from "react"
import { reportError } from "@/lib/observability"

// Catches errors thrown from app/layout.tsx itself. When the root layout
// crashes, the entire provider tree (next-intl, ThemeProvider, shadcn) is
// gone, so this file intentionally breaks two rules that apply elsewhere:
//   - Strings are hardcoded English (no next-intl provider — i18n exception)
//   - Raw <button> is used (no ThemeProvider, so shadcn token vars are unset)
const GlobalError = ({ error }: { error: Error & { digest?: string } }) => {
  useEffect(() => {
    reportError(error, { surface: "global-error", digest: error.digest })
  }, [error])

  // `reset()` only re-renders the client tree from the payload already in
  // hand, so an error that came from the server (an RSC render, a server
  // action's re-render) is thrown again from the same payload and "Try again"
  // could never clear it. A reload refetches through the proxy.
  const handleReload = () => {
    window.location.reload()
  }

  return (
    <html lang="en">
      <body className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
        {/* i18n exception: root layout crashed — no NextIntlClientProvider */}
        <h2 className="text-xl font-semibold">Something went wrong</h2>
        <p className="text-muted-foreground max-w-prose">
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <button
          type="button"
          onClick={handleReload}
          className="rounded-md border px-4 py-2 text-sm hover:bg-accent"
        >
          Try again
        </button>
      </body>
    </html>
  )
}

export default GlobalError
